<span mat-dialog-title class="text-xl" *ngIf="confirmTitle">
  {{ confirmTitle | transloco }}
</span>
<div mat-dialog-content>
  <p *ngIf="confirmMessage" [innerHTML]="confirmMessage | transloco"></p>
  <mat-form-field *ngIf="showDescription" class="w-full">
    <textarea
      matInput
      [placeholder]="'UI.WORKSPACE_DIALOG.INFORM_REASON' | transloco"
      [(ngModel)]="description"
    ></textarea>
  </mat-form-field>
</div>
<div mat-dialog-actions class="p-6 pt-5 bg-slate-50 dark:bg-neutral-700 flex justify-end">
  <button mat-button id="button-confirm-cancel" (click)="dialogRef.close(false)" *ngIf="!hideCancelButton">
    {{ negativeButtonLabel || 'UI.GENERAL.CANCEL' | transloco }}
  </button>
  <button
    mat-raised-button
    color="primary"
    id="button-confirm-ok"
    [disabled]="minLenght && description?.length < minLenght"
    (click)="dialogRef.close(description || true)"
  >
    {{ positiveButtonLabel || 'UI.GENERAL.OK' | transloco }}
  </button>
</div>
